/*
    node_js
    2/22/2021 7:41 PM
    by Oleksandr
*/

import CWP from "./cwp/CWP";
import ATG from "./atg/ATG";
import {ProtectedRoute} from "../auth/ProtectedRoute";

const PLT = () => {
    return (
        <>
            <CWP isPlt={true}/>
            <ATG isPlt={true}/>
        </>
    )
}
export default PLT;